import { postData, getData } from "../api-client";
import {
  LOGIN,
  USER,
  WEB_USER,
  SIGNUP,
  FORGOT,
  CHANGE_PASSWORD
} from "../../shared/constants/routing-constants";

export function postLogin(jsonData: any) {
  return postData(`${USER}/${LOGIN}`, jsonData);
}

export function postSignup(jsonData: any) {
  return postData(`${USER}/${SIGNUP}`, jsonData);
}

export function getForgotPassword(email: string) {
  return getData(`${USER}/${FORGOT}?email=${email}`);
}

export function postChangePassword(jsonData: any) {
  return postData(`${USER}/${CHANGE_PASSWORD}`, jsonData);
}
